<template>
  <div>
    <!-- Cytoscape container -->
    <div ref="chartContainerBlock" id="cydiff"></div>
    <!-- Popup menu for node actions -->
    <div v-if="showNodePopup" :style="popupStyle" class="popup-menu" @mouseleave="hidePopupMenu">
      <ul>
        <li v-if="menuitems.includes('expandNode') && hasHiddenChildren(selectedNode)" @click="expandNode"> Expand Node
        </li>
        <li v-if="menuitems.includes('collapseNode') && hasVisibleChildren(selectedNode)" @click="collapseNode">
          Collapse Node</li>
        <!-- <li v-if="menuitems.includes('expandNode') && hasChildNodes(selectedNode)" @click="expandNode">Expand Node</li> -->
        <!-- <li v-if="menuitems.includes('collapseNode') && hasChildNodes(selectedNode)" @click="collapseNode">Collapse Node</li> -->
        <li v-if="menuitems.includes('addSubNode')" @click="addSubNode">Add Node</li>
        <!-- <li @click="addArray">Add Array</li>
          <li @click="addArrayelements">Add Array elements</li>
          <li @click="addproperties">Add properties</li> -->
        <li
          v-if="menuitems.includes('addNewVisit') && selectedNode && selectedNode._private && selectedNode._private.data && selectedNode._private.data.properties && selectedNode._private.data.properties.Type === 'Visit'"
          @click="addNewVisit">Add New Visit</li>
        <li v-if="menuitems.includes('deleteNode')" @click="deleteNode">Delete Node</li>
        <li v-if="menuitems.includes('showdetails')" @click="showdetails">Show Details</li>
        <li v-if="menuitems.includes('showproperties')" @click="showproperties">Show Details</li>
        <!-- <li v-if="menuitems.includes('showformmodel')" @click="showformmodel">Show Form</li> -->
        <li
          v-if="menuitems.includes('showformmodel') && selectedNode && selectedNode._private && selectedNode._private.data && selectedNode._private.data.properties && selectedNode._private.data.properties.FormId && selectedNode._private.data.properties.Type === 'Form' && selectedpatientid != ''"
          @click="showformmodel">
          View Form
        </li>
        <li
          v-if="menuitems.includes('gotosubjectgraph') && selectedNode && selectedNode._private && selectedNode._private.data && selectedNode._private.data.properties && selectedNode._private.data.properties.SubjectId"
          @click="showsubjectgraph">
          View Subject
        </li>
        <li
          v-if="menuitems.includes('gotositegraph') && selectedNode && selectedNode._private && selectedNode._private.data && selectedNode._private.data.properties && selectedNode._private.data.properties.SiteId"
          @click="showsitegraph">
          View Site
        </li>
        <li
          v-if="menuitems.includes('changevisitstatus') && selectedNode && selectedNode._private && selectedNode._private.data && selectedNode._private.data.properties && selectedNode._private.data.properties.Type === 'Visit' && selectedpatientid != ''"
          @click="changevisitstatusfun">
          Change Status
        </li>

      </ul>
    </div>

    <!-- Add Arrayelement Modal -->
    <div v-if="arrayelementspopup" class="modal-wrapper is-visible">
      <div class="modal-container">
        <div class="titleclass">
          <h4 class="px-3 mt-1">Add Array Element</h4>
          <div class="closebutton mt-1">
            <a style="color: white" class="close-link">
              <i class="fa fa-times" @click.prevent="closeaddarrayelementspopup"></i>
            </a>
          </div>
        </div>
        <div class="modelbody p-0">
          <div class="mb-3 p-2">
            <div class="form-group">
              <div class="d-flex flex-column flex-lg-row">
                <div class="col-lg-12 my-2">
                  <label for="propname">New array element name</label>
                  <input type="text" class="form-control" v-model="arrayelementname" id="propname" />
                </div>
              </div>
              <div class="d-flex justify-content-center my-3">
                <button class="save_btn py-1 px-4">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Array Modal -->
    <div v-if="addarraypopup" class="modal-wrapper is-visible">
      <div class="modal-container">
        <div class="titleclass">
          <h4 class="px-3 mt-1">Add Array</h4>
          <div class="closebutton mt-1">
            <a style="color: white" class="close-link">
              <i class="fa fa-times" @click.prevent="closeaddarraypopup"></i>
            </a>
          </div>
        </div>
        <div class="modelbody p-0">
          <div class="mb-3 p-2">
            <div class="form-group">
              <div class="d-flex flex-column flex-lg-row">
                <div class="col-lg-12 my-2">
                  <label for="propname">New Node name</label>
                  <input type="text" class="form-control" v-model="subnodearrayname" id="propname" />
                </div>
              </div>
              <div class="d-flex justify-content-center my-3">
                <button class="save_btn py-1 px-4">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add node Modal -->
    <div v-if="addnodepopup" class="modal-wrapper is-visible">
      <div class="modal-container">
        <div class="titleclass">
          <h4 class="px-3 mt-1">Add Node</h4>
          <div class="closebutton mt-1">
            <a style="color: white" class="close-link">
              <i class="fa fa-times" @click.prevent="closeaddnodepopup"></i>
            </a>
          </div>
        </div>
        <div class="modelbody p-0">
          <div class="mb-3 p-2">
            <div class="form-group">
              <div class="d-flex flex-column flex-lg-row">
                <div class="col-lg-12 my-2">
                  <label for="propname">New Node name</label>
                  <input type="text" class="form-control" v-model="subnodename" id="propname" />
                </div>
              </div>
              <div class="d-flex justify-content-center my-3">
                <button class="save_btn py-1 px-4" @click.prevent="addsubnodecall()">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- create graph Modal -->
    <div v-if="creategraphpopup" class="modal-wrapper is-visible">
      <div class="modal-container">
        <div class="titleclass">
          <h4 class="px-3 mt-1">Create Graph</h4>
          <div class="closebutton mt-1">
            <a style="color: white" class="close-link">
              <i class="fa fa-times" @click.prevent="closecreategraph"></i>
            </a>
          </div>
        </div>
        <div class="modelbody p-0">
          <div class="mb-3 p-2">
            <div class="form-group">
              <div class="d-flex flex-column flex-lg-row">
                <div class="col-lg-12 my-2">
                  <label for="propname">Graph name</label>
                  <input type="text" class="form-control" v-model="newgraphname" id="propname" />
                </div>
              </div>
              <div class="d-flex justify-content-center my-3">
                <button class="save_btn py-1 px-4">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup Details Modal -->
    <div v-if="detailspopup" class="modal-wrapper is-visible">
      <div class="modal-container">
        <div class="titleclass">
          <h4 class="px-3 mt-1">Details</h4>
          <div class="closebutton mt-1">
            <a style="color: white" class="close-link">
              <i class="fa fa-times" @click.prevent="closedetailsModal"></i>
            </a>
          </div>
        </div>
        <div class="modelbody p-0">
          <div class="mb-3 p-2">
            <div class="form-group">
              <div class="d-flex flex-column flex-lg-row">
                <div class="col-lg-12 my-2">
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>Key</th>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(value, key) in nodeproperties.data" :key="key">
                        <td>{{ key }}</td>
                        <td>{{ value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="d-flex justify-content-center my-3">
                <button class="save_btn py-1 px-4" @click="closedetailsModal">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup Add properties Modal -->
    <div v-if="addpropertiespopup" class="modal-wrapper is-visible">
      <div class="modal-container">
        <div class="titleclass">
          <h4 class="px-3 mt-1">Add properties</h4>
          <div class="closebutton mt-1">
            <a style="color: white" class="close-link">
              <i class="fa fa-times" @click.prevent="cloaseaddproperties"></i>
            </a>
          </div>
        </div>
        <div class="modelbody p-0">
          <div class="mb-3 p-2">
            <div class="form-group">
              <div class="d-flex flex-column flex-lg-row">
                <div class="col-lg-12 my-2">
                  <div class="form-group">
                    <label for="propname">Property name</label>
                    <input type="text" class="form-control" v-model="propname" id="propname" />
                  </div>
                  <div class="form-group">
                    <label for="propvalue">Property value</label>
                    <input type="text" class="form-control" v-model="propvalue" id="propvalue" />
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center my-3">
                <button class="save_btn py-1 px-4">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import axios from "axios";
import cytoscape from "cytoscape";
import dagre from "cytoscape-dagre"; // Import the Dagre extension
import store from "@/store";
import 'qtip2/dist/jquery.qtip.css';
import 'qtip2';
import klay from "cytoscape-klay";
import qtip from "cytoscape-qtip";
cytoscape.use(qtip);
cytoscape.use(dagre); // Register Dagre with Cytoscape
cytoscape.use(klay);

export default {
  name: "NetworkXGraph",
  props: {
    selectedgraphid: {
      type: String,
      default: ""
    },
    selectedpatientid: {
      type: String,
      default: ""
    },
    graphdata: {
      type: Object,
      default: () => ({}),
    },
    selectedLayout: {
      type: String,
      default: "cose"
    },
    menuitems: {
      type: Array,
      default: () => ["expandNode", "collapseNode", "deleteNode", "showdetails"]
    },
    collapsedtypes: {
      type: Array,
      default: () => []
    },
    donotcollapse: {
      type: Array,
      default: () => []
    },
    customlabels: {
      type: Array,
      default: () => []
    },
    executeParentFunction: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      cydiff: null,
      authToken: store.getters.getIdToken,
      rootId: null,
      templatedetails: [],
      // Default layout is "dagre"
      baseurl: process.env.VUE_APP_Service_URL,
      // For popup menu handling:
      showNodePopup: false,
      popupPosition: { x: 0, y: 0 },
      selectedNode: null,
      nodeproperties: null,
      detailspopup: false,
      addpropertiespopup: false,
      propname: "",
      propvalue: "",
      creategraphpopup: false,
      newgraphname: "",
      addnodepopup: false,
      subnodename: "",
      addarraypopup: false,
      subnodearrayname: "",
      arrayelementspopup: false,
      arrayelementname: "",
      mouseX: 0,
      mouseY: 0,
      selectedorientation: "LR",
      graphshapes: {
        "Rectangle": "rectangle",
        "Ellipse": "ellipse",
        "Diamond": "diamond",
        "Octagon": "octagon",
        "Round-rectangle": "round-rectangle",
        "Round-tag": "round-tag"
      },
      unwantedproperties: ["Color", "FormId", "SiteId", "SubjectId", "Shapes"]
    };
  },
  computed: {
    popupStyle() {
      return {
        position: "absolute",
        top: this.mouseY - 5 + "px",
        left: this.mouseX + 10 + "px",
        zIndex: 9999,
        background: "#fff",
        border: "1px solid #ccc",
        padding: "5px",
      };
    },
  },
  watch: {
    graphdata: {
      handler() {
        console.log("graphdata", this.graphdata);
        this.loadGraph();
        if (this.selectedLayout == 'grid') {
          setTimeout(() => {
            this.applyLayout();
          }, 500)
        }
      },
      immediate: true,
      deep: true,
    },
    customlabels: {
      handler() {
        this.loadGraph();
        this.applyLayout();
      },
      immediate: true,
      deep: true,
    },
    selectedLayout() {
      this.loadGraph();
      this.applyLayout();
    },
  },
  beforeUnmount() {
    window.removeEventListener("mousemove", this.updateMousePosition);
  },
  async mounted() {
    window.addEventListener("mousemove", this.updateMousePosition);
  },
  methods: {
    hasVisibleChildren(node) {
      return node && node.outgoers('node').length > 0;
    },

    // Any children in your original data that aren’t in the current Cytoscape instance yet
    hasHiddenChildren(node) {
      if (!node || !this.graphdata || !this.graphdata.links) return false;
      return this.graphdata.links.some(link =>
        link.source === node.id() &&
        this.cydiff.getElementById(link.target).empty()
      );
    },
    hasChildNodes(node) {
      // use Cytoscape’s outgoers to see if this node has any outgoing edges → child nodes
      return node && node.outgoers('node').length > 0;
    },
    selectorientationfun(neworientation) {
  this.selectedorientation = neworientation;
  this.applyLayout();
  // nudge taxi to prefer the main axis
  if (this.cydiff) {
    this.cydiff.style()
      .selector('edge')
      .style('taxi-direction', neworientation === 'LR' ? 'horizontal' : 'vertical')
      .update();
  }
},
    zoomIn() {
      if (this.cydiff) {
        const currentZoom = this.cydiff.zoom();
        // Increase zoom by 20%
        this.cydiff.zoom(currentZoom * 1.2);
      }
    },
    zoomOut() {
      if (this.cydiff) {
        const currentZoom = this.cydiff.zoom();
        // Decrease zoom by 20%
        this.cydiff.zoom(currentZoom * 0.8);
      }
    },
    updateMousePosition(event) {
      // Get the bounding rectangle of the component
      const rect = this.$refs.chartContainerBlock.getBoundingClientRect();
      // Calculate the mouse X and Y positions relative to the component
      if (!this.showNodePopup) {
        this.mouseX = event.clientX - rect.left;
        this.mouseY = event.clientY - rect.top;
      }
    },
    async addNewVisit() {
      if (this.selectedNode._private && this.selectedNode._private.data && this.selectedNode._private.data.properties) {
        let currentvisitdata = { ...this.selectedNode._private.data };
        this.$emit('uncheduledvisit', currentvisitdata);
      }
    },
    async deleteNode() {
      this.$emit('deleteNode', this.selectedNode);
    },
    async showdetails() {
      this.$emit('showdetails', this.selectedNode);
    },
    async changevisitstatusfun() {
      if (
        this.selectedNode._private &&
        this.selectedNode._private.data &&
        this.selectedNode._private.data.properties
      ) {
        let properties = { ...this.selectedNode._private.data.properties };
        console.log("properties", properties);
        let changeStatus = {
          "visitNo": properties.VisitNo,
          "status": properties.VisitStatus
        };
        console.log("changeStatus", changeStatus);
        this.$emit("changevisitstatusmodel", changeStatus);
      }
    },
    async showsubjectgraph() {
      if (
        this.selectedNode._private &&
        this.selectedNode._private.data &&
        this.selectedNode._private.data.properties
      ) {
        let properties = { ...this.selectedNode._private.data.properties };
        // Use a safe call to check for "Color"
        if (Object.prototype.hasOwnProperty.call(properties, "Color")) {
          delete properties.Color;
        }
        this.$emit("showsubjectgraph", properties);
      }
    },
    async showsitegraph() {
      if (
        this.selectedNode._private &&
        this.selectedNode._private.data &&
        this.selectedNode._private.data.properties
      ) {
        let properties = { ...this.selectedNode._private.data.properties };
        // Use a safe call to check for "Color"
        if (Object.prototype.hasOwnProperty.call(properties, "Color")) {
          delete properties.Color;
        }
        this.$emit("showsitegraph", properties);
      }
    },
    async showformmodel() {
      if (
        this.selectedNode._private &&
        this.selectedNode._private.data &&
        this.selectedNode._private.data.properties
      ) {
        let properties = { ...this.selectedNode._private.data.properties };
        // Use a safe call to check for "Color"
        if (Object.prototype.hasOwnProperty.call(properties, "Color")) {
          delete properties.Color;
        }
        this.$emit("showformmodel", properties);
      }
    },
    async showproperties() {
      if (
        this.selectedNode._private &&
        this.selectedNode._private.data &&
        this.selectedNode._private.data.properties
      ) {
        let properties = { ...this.selectedNode._private.data.properties };
        // Use a safe call to check for "Color"
        this.unwantedproperties.forEach((eachunwantedproperties) => {
          if (Object.prototype.hasOwnProperty.call(properties, eachunwantedproperties)) {
            delete properties[eachunwantedproperties];
          }
        })
        this.$emit("showproperties", properties);
      }
    },
    computeNodeShape(node) {
      if (node.properties) {
        if (node.properties.Shapes) {
          return node.properties.Shapes;
        }
        return "ellipse";

      }
      return "ellipse";
    },
    async expandNode() {
      this.showNodePopup = false;

      if (this.selectedNode.data('expanded')) {
        return;
      }

      const selectedId = this.selectedNode.id();

      // Find child links and nodes
      const childLinks = this.graphdata.links.filter(link => link.source === selectedId);
      const childNodeIds = childLinks.map(link => link.target);
      const childNodes = this.graphdata.nodes.filter(node => childNodeIds.includes(node.id));

      // Prepare new elements to add
      const newElements = [];
      childNodes.forEach(node => {
        if (this.cydiff.getElementById(node.id).empty()) {
          let color = "#0074D9"; // default color
          if (node.properties && node.properties.Color && this.isValidCssColor(node.properties.Color)) {
            color = node.properties.Color;
          }
          newElements.push({
            data: {
              id: node.id,
              label: node.label || node.data || node.id,
              ...node,
              shape: this.computeNodeShape(node),
              color: color,
            },
          });
        }
      });
      const hasEdge = (src, tgt, label = "") => {
  return this.cy
    .edges()
    .some(e =>
      e.data("source") === src &&
      e.data("target") === tgt &&
      (e.data("label") || "") === (label || "")
    );
};

childLinks.forEach(link => {
  // If an identical connection already exists, skip
  if (hasEdge(link.source, link.target, link.label || "")) return;

  // Use a stable id but do NOT rely on it for dedupe
  const edgeId =
    link.id || `e:${link.source}->${link.target}:${(link.label || "").trim()}`;

  newElements.push({
    data: {
      id: edgeId,
      source: link.source,
      target: link.target,
      label: link.label || ""
    }
  });
});

      // Add the new elements
      this.cydiff.add(newElements);
      this.selectedNode.data('expanded', true);

      // Re-run layout
      this.applyLayout();

      // Reinitialize tooltips on any new nodes
      this.initializeTooltips();
    },
    hideAllTooltips() {
      if (this.cydiff) {
        this.cydiff.nodes().forEach((node) => {
          const api = node.qtip('api');
          if (api) {
            // To just hide:
            api.destroy();
            // Or, if you want to remove them completely, use:
            // api.destroy();
          }
        });
      }
    },
    initializeTooltips() {
      this.cydiff.nodes().forEach((node) => {
        if (!node.scratch('qtipInitialized')) {
          // Build tooltip text: start with the node label.
          let tooltipText = node.data('label');

          node.qtip({
            content: { text: tooltipText },
            show: { event: 'mouseover', solo: true },
            // Update the hide event to also include "click" so it hides on mouse click.
            hide: { event: 'mouseout unfocus'},
            position: {
              my: 'top center',
              at: 'bottom center'
            },
            style: {
              classes: 'qtip-bootstrap',
              tip: {
                width: 16,
                height: 8
              }
            }
          });
          node.scratch('qtipInitialized', true);
        }
      });
    },
    async addsubnodecall() {
      this.$emit('newnodecreate', this.subnodename, this.selectedNode);
      this.closeaddnodepopup();
    },
    async createGraph() {
      this.creategraphpopup = true;
    },
    async closecreategraph() {
      this.creategraphpopup = false;
    },

    async addproperties() {
      this.addpropertiespopup = true;
    },
    async cloaseaddproperties() {
      this.addpropertiespopup = false;
    },


    closedetailsModal() {
      this.detailspopup = false;
    },
    async loadGraph() {
      // ① Convert JSON → Cytoscape elements
      const elements = this.convertNodeLinkToCytoscape(this.graphdata);

      // ② Find the first “pure node” (no source/target) to use as root
      const firstNodeEl = elements.find(el => el.data && el.data.id && !el.source && !el.target);
      this.rootId = firstNodeEl ? firstNodeEl.data.id : null;

      // ③ If we have a root, pin it at x=50,y=300
      if (this.rootId) {
        elements.forEach(el => {
          if (el.data.id === this.rootId) {
            el.position = { x: 50, y: 300 };
          }
        });
      }

      // ④ Instantiate cytoscape in “preset” mode so that the root’s position is honored
      this.cydiff = cytoscape({
        container: document.getElementById("cydiff"),
        elements: elements,
        layout: { name: "preset" },
        wheelSensitivity: 0.2,
        style: [
          {
            selector: "node",
            style: {
              shape: "data(shape)",
              label: "data(label)",
              "background-color": "data(color)",

              // keep text readable
              "font-size": 16,

              // wrap text inside the shape
              "text-wrap": "wrap",
              "text-max-width": 100,          // <= a bit less than your node width (120)
              "text-overflow-wrap": "anywhere", // breaks long tokens/IDs if needed
              "text-halign": "center",
              "text-valign": "center",
              "text-margin-x": 2,
              "text-margin-y": 2,

              color: "black",
              width: 120,
              height: 120
            }
          },
         {
  selector: "edge",
  style: {
    "curve-style": "taxi",
    "taxi-direction": "auto",          // or "horizontal"/"vertical"
    "taxi-turn": "data(taxiTurn)",

    "width": 2,
    "opacity": 1,
    "line-dash-pattern": [6, 4],

    "target-arrow-shape": "triangle",
  }
},
{
  selector: "edge[label]",
  style: { "text-rotation": "autorotate", "font-size": 10 }
}
        ],
      });

      // ⑤ Grabify the root immediately (so it’s draggable)
      if (this.rootId) {
        const rootNode = this.cydiff.getElementById(this.rootId);
        if (rootNode && !rootNode.empty()) {
          rootNode.unlock();
          rootNode.grabify();
        }
      }

      // ⑥ Run the “real” layout (Cose with randomize:false)
      if (this.selectedLayout != 'grid') {
        this.$nextTick(() => {
          this.applyLayout();
          setTimeout(() => {
            this.cydiff.fit(this.cydiff.elements(), 50);
          }, 300);
        });
      }

      // ⑦ Tooltips / event handlers
      this.initializeTooltips();
      // Other event handlers…
      this.cydiff.on("tap", "node", (event) => {
        const node = event.target;
        this.selectedNode = node;
        const clickEvent = event.originalEvent;
        this.popupPosition = {
          x: clickEvent.clientX + 10,
          y: clickEvent.clientY + 10,
        };
        this.showNodePopup = true;
      });

      this.cydiff.on("tap", (event) => {
        if (event.target === this.cydiff) {
          this.showNodePopup = false;
        }
      });

      this.cydiff.on("zoom pan", () => {
        if (this.showNodePopup) {
          this.showNodePopup = false;
        }
      });


    },
// small, stable color from string (no dependency)
edgeColorFrom(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  const hue = Math.abs(h) % 360;
  return `hsl(${hue}, 70%, 45%)`;
},

// group edges between the same two nodes and assign lane offsets
assignEdgeLanes(links, baseTurn = 30, laneGap = 16) {
  const groups = new Map();

  // group undirected (A–B == B–A); change if your graph is directed
  for (const l of links) {
    const key = l.source < l.target ? `${l.source}|${l.target}` : `${l.target}|${l.source}`;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(l);
  }

  for (const arr of groups.values()) {
    const n = arr.length;
    if (n === 1) {
      arr[0].__laneIndex = 0;
      arr[0].__taxiTurn  = baseTurn;
      arr[0].__lineStyle = "solid";
      continue;
    }
    // center-out distribution: -k ... 0 ... +k
    const mid = (n - 1) / 2;
    arr.forEach((edge, i) => {
      const offsetIdx = i - mid;                // e.g., for 3 -> -1, 0, +1
      edge.__laneIndex = i;
      edge.__taxiTurn  = baseTurn + offsetIdx * laneGap;
      edge.__lineStyle = i % 2 ? "dashed" : "solid";
    });
  }
},

    async isValidCssColor(strColor) {
      const s = new Option().style;
      s.color = strColor;
      // If the browser recognized the color, it will normalize it to a valid string.
      return s.color === strColor.toLowerCase();
    },
    /**
     * Convert NetworkX node-link JSON into Cytoscape elements.
     */
    convertNodeLinkToCytoscape(data) {
  if (!data || !data.nodes || !data.links) {
    console.error("Invalid graph data provided", data);
    return [];
  }

  // --- Helpers (local) ---
  // deterministic color from a string
  const edgeColorFrom = (str) => {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
    const hue = Math.abs(h) % 360;
    return `hsl(${hue}, 70%, 45%)`;
  };

  // assign "lanes" to parallel edges so they don't overlap;
  // directed grouping (A->B edges grouped separately from B->A)
  const assignEdgeLanes = (links, baseTurn = 30, laneGap = 16) => {
    const groups = new Map();
    for (const l of links) {
      const key = `${l.source}->${l.target}`;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(l);
    }
    for (const arr of groups.values()) {
      const n = arr.length;
      if (n === 1) {
        arr[0].__laneIndex = 0;
        arr[0].__taxiTurn  = baseTurn;
        arr[0].__lineStyle = "solid";
        continue;
      }
      const mid = (n - 1) / 2;
      arr.forEach((edge, i) => {
        const offsetIdx = i - mid;                // -k ... 0 ... +k
        edge.__laneIndex = i;
        edge.__taxiTurn  = baseTurn + offsetIdx * laneGap;
        edge.__lineStyle = i % 2 ? "dashed" : "solid";
      });
    }
  };

  // --- Precompute lookups ---
  const nodeMap = {};
  data.nodes.forEach((n) => (nodeMap[n.id] = n));

  // lanes for parallel edges
  assignEdgeLanes(data.links);

  // --- Determine nodes hidden by collapsed types ---
  const collapsedTypes = this.collapsedtypes || [];
  const hiddenNodes = new Set();

  // hide immediate children of collapsed parents (except when child is also collapsed type)
  data.links.forEach((link) => {
    const src = nodeMap[link.source];
    const srcType = (src && src.properties && src.properties.Type) || src?.type;
    if (srcType && collapsedTypes.includes(srcType)) {
      const tgt = nodeMap[link.target];
      const tgtType = (tgt && tgt.properties && tgt.properties.Type) || tgt?.type;
      if (!collapsedTypes.includes(tgtType)) hiddenNodes.add(link.target);
    }
  });
  // propagate hiding downwards
  let added;
  do {
    added = false;
    data.links.forEach((link) => {
      if (hiddenNodes.has(link.source)) {
        const tgt = nodeMap[link.target];
        const tgtType = (tgt && tgt.properties && tgt.properties.Type) || tgt?.type;
        if (!collapsedTypes.includes(tgtType) && !hiddenNodes.has(link.target)) {
          hiddenNodes.add(link.target);
          added = true;
        }
      }
    });
  } while (added);

  // --- Build Cytoscape elements ---
  const elements = [];

  // Nodes
  data.nodes.forEach((node) => {
    if (hiddenNodes.has(node.id)) return;

    const nodeType =
      (node.properties && node.properties.Type) || node.type || undefined;
    const isCollapsible = nodeType && collapsedTypes.includes(nodeType);

    // color
    let color = "#0074D9";
    if (
      node.properties &&
      node.properties.Color &&
      this.isValidCssColor(node.properties.Color)
    ) {
      color = node.properties.Color;
    }

    // shape
    const shape = (node.properties && node.properties.Shapes) || "ellipse";

    // label (supports customlabels mapping)
    let label = node.label || node.data || node.id;
    if (node.properties && node.properties.Type) {
      const cfg = this.customlabels.find(
        (item) => item.Nodetype === node.properties.Type
      );
      if (
        cfg &&
        cfg.Custlabel &&
        cfg.Custlabel !== "label" &&
        node.properties[cfg.Custlabel]
      ) {
        label = node.properties[cfg.Custlabel];
      }
    }
    if (node.properties?.Status) label += " – " + node.properties.Status;
    if (node.properties?.VisitStatus) label += " – " + node.properties.VisitStatus;

    elements.push({
      data: {
        // spread original fields first
        ...node,
        // then our computed/normalized fields
        id: node.id,
        type: nodeType,
        shape,
        color,
        collapsible: !!isCollapsible,
        expanded: !isCollapsible,
        label,
      },
    });
  });

  const visibleIds = new Set(elements.map((el) => el.data.id));

  // Edges
  data.links.forEach((link) => {
    if (!visibleIds.has(link.source) || !visibleIds.has(link.target)) return;

    const id =
      link.id || `${link.source}-${link.target}-${link.__laneIndex || 0}`;

    const color =
      (link.color && this.isValidCssColor(link.color))
        ? link.color
        : edgeColorFrom(`${link.source}|${link.target}|${link.label || ""}`);

    elements.push({
      data: {
        id,
        source: link.source,
        target: link.target,
        label: link.label || "",

        // lane/routing info for taxi edges & styling
        taxiTurn: link.__taxiTurn || 30,
        laneIndex: link.__laneIndex || 0,
        lineStyle: link.__lineStyle || "solid",
        color,
      },
    });
  });

  return elements;
},

    // Hide the popup menu.
    hidePopupMenu() {
      this.showNodePopup = false;
    },


    // Collapse the selected node by recursively removing all descendant nodes.
    collapseNode() {
      if (!this.selectedNode || this.selectedNode.removed()) return;

      const visited = new Set();

      const removeDescendants = (node) => {
        if (!node || typeof node.removed !== 'function' || node.removed() || visited.has(node.id())) return;
        visited.add(node.id());

        const children = node.outgoers("node");

        children.forEach((child) => {
          const childData = child.data();
          let childType = null;
          if (childData) {
            if (childData.properties && childData.properties.Type) {
              childType = childData.properties.Type;
            } else if (childData.type) {
              childType = childData.type;
            }
          }

          if (this.donotcollapse.includes(childType)) {
            return;
          }
          removeDescendants(child);
          if (!child.removed()) {
            child.remove();
          }
        });
      };

      removeDescendants(this.selectedNode);
      this.selectedNode.data("expanded", false);

      this.applyLayout();
      this.hidePopupMenu();
      this.cydiff.resize();
    },

    // --- NEW METHOD: Sort all subnodes at every level ---
    sortAllNodes() {
      if (!this.cydiff || !this.rootId) {
        console.warn("Cytoscape or rootId not set yet.");
        return;
      }

      // Example: using breadthfirst layout for sorting; you can adjust as needed.
      this.cydiff.layout({
        name: "breadthfirst",
        roots: [this.rootId],
        directed: false,
        fit: true,
        circle: false,
        spacingFactor: 1.2,
        padding: 30,
        sort: (a, b) => {
          const aLabel = String(a.data("label")).toLowerCase();
          const bLabel = String(b.data("label")).toLowerCase();
          if (!isNaN(aLabel) && !isNaN(bLabel)) {
            return parseFloat(aLabel) - parseFloat(bLabel);
          }
          return aLabel.localeCompare(bLabel);
        },
        animate: true,
        animationDuration: 500
      }).run();

      this.hidePopupMenu();
    },

    addArrayelements() {
      this.arrayelementspopup = true;
    },
    closeaddarrayelementspopup() {
      this.arrayelementspopup = false;
    },

    addArray() {
      this.addarraypopup = true;
      this.hidePopupMenu();
    },
    closeaddarraypopup() {
      this.addarraypopup = false;
    },

    addSubNode() {
      this.addnodepopup = true;
      this.hidePopupMenu();
    },
    closeaddnodepopup() {
      this.addnodepopup = false;
    },

    // --- NEW HELPER: Return layout configuration based on selected layout ---
    getLayoutConfig() {
      let layoutConfig = {};
      const orientation = this.selectedorientation; // e.g., "TB" or "LR"

      switch (this.selectedLayout) {
        case "dagre":
          layoutConfig = {
            name: "dagre",
            rankDir: orientation,
            fit: true,
            padding: 30,
            nodeSep: 50,
            rankSep: 100,
            edgeSep: 10,
            ranker: "longest-path",
            animate: true,
            animationDuration: 500,
          };
          break;
        case "breadthfirst":
          layoutConfig = {
            name: "breadthfirst",
            roots: [this.rootId],
            rankDir: orientation,
            directed: false,
            fit: true,
            circle: false,
            spacingFactor: 1.2,
            padding: 30,
            animate: true,
            animationDuration: 500,
          };
          break;
        case "grid":
          layoutConfig = {
            name: "grid",
            // Only count nodes (not edges)
            rows: Math.ceil(Math.sqrt(this.cydiff ? this.cydiff.nodes().length : 1)),
            animate: true,
            animationDuration: 500,
          };
          break;
        case "circle":
          layoutConfig = {
            name: "circle",
            animate: true,
            animationDuration: 500,
          };
          break;
        case "concentric":
          layoutConfig = {
            name: "concentric",
            animate: true,
            animationDuration: 500,
          };
          break;
        case "cose":
          layoutConfig = {
            name: "cose",
            randomize: false,   // start from preset positions
            avoidOverlap: true,    // guarantee no overlaps
            nodeOverlap: 20,      // at least 20px padding between each node
            idealEdgeLength: 100,
            edgeElasticity: 100,
            gravity: 0.1,
            componentSpacing: 40,
            numIter: 2000,
            animate: false,
            animationDuration: 500
          };
          break;
        case "klay":
          {
            let klayDirection = "DOWN";
            if (this.selectedorientation === "LR") {
              klayDirection = "RIGHT";
            }
            layoutConfig = {
              name: "klay",
              nodeDimensionsIncludeLabels: true, // so the layout considers label size
              fit: true,
              padding: 20,
              klay: {
                direction: klayDirection,
                spacing: 40,
                edgeRouting: "ORTHOGONAL"   // ← ask KLAY to compute orthogonal routes
              },
              animate: true,
              animationDuration: 500,
            };
          }
          break;
        default:
          layoutConfig = {
            name: "dagre",
            rankDir: orientation,
            nodeSep: 50,
            rankSep: 100,
            edgeSep: 10,
            ranker: "longest-path",
            animate: true,
            animationDuration: 500,
          };
          break;
      }
      return layoutConfig;
    },
    getContrastYIQ(hexcolor) {
      // Remove the '#' if it exists.
      hexcolor = hexcolor.replace("#", "");
      const r = parseInt(hexcolor.substr(0, 2), 16);
      const g = parseInt(hexcolor.substr(2, 2), 16);
      const b = parseInt(hexcolor.substr(4, 2), 16);
      // Compute brightness using the YIQ formula.
      const yiq = (r * 299 + g * 587 + b * 114) / 1000;
      return yiq >= 128 ? "black" : "white";
    },
    // --- NEW METHOD: Apply the current layout to the graph ---
    applyLayout() {
      if (!this.cydiff) return;

      const cfg = this.getLayoutConfig();
      cfg.fit = cfg.fit !== false;
      cfg.padding = cfg.padding || 30;

      // If using 'cose', pin the root node at x=50,y=300 so layout won't move it.
      if (this.selectedLayout === "cose" && this.rootId) {
        const rootNode = this.cydiff.getElementById(this.rootId);
        if (rootNode && !rootNode.empty()) {
          // Manually position it and lock it so Cose respects that position
          rootNode.position({ x: 50, y: 300 });
          rootNode.lock();
        }
      }

      // Run the layout

      // As soon as layout finishes, unlock + grabify the root so it's draggable
      this.cydiff.once("layoutstop", () => {
        if (this.selectedLayout === "cose" && this.rootId) {
          const rootNode = this.cydiff.getElementById(this.rootId);
          if (rootNode && !rootNode.empty()) {
            // Delay by one tick so Cytoscape’s internals have fully updated
            setTimeout(() => {
              rootNode.unlock();
              rootNode.grabify();
              rootNode.style('z-index', 9999);
            }, 0);
          }
        }
        this.cydiff.fit(this.cydiff.elements(), 50);
      });
      this.cydiff.layout(cfg).run();
    },



  },
};

</script>
<style scoped>
@import "../../assets/css/style.css";

#cydiff {
  width: 100%;
  height: 600px;
}

.popup-menu {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 5px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.popup-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.popup-menu li {
  padding: 3px 8px;
  cursor: pointer;
}

.popup-menu li:hover {
  background: #f0f0f0;
}

.modal-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  pointer-events: auto;
  overflow: hidden;
  z-index: 9999;
}

.modal-container {
  background: #fff;
  width: 80%;
  max-width: 600px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease-in-out;
}

.is-visible {
  opacity: 1;
  pointer-events: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.table th,
.table td {
  padding: 8px;
  border: 1px solid #ddd;
}

.table th {
  background-color: #f4f4f9;
  font-weight: bold;
}

.table-striped tbody tr:nth-child(odd) {
  background-color: #f9f9f9;
}
</style>